export const cellTags = ['build-table', 'area-calculation']
